import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { CTRL_8 } from '../../../validators/8/ctrl8';
import { CTRL_9 } from '../../../validators/9/ctrl9';
import { TypePers } from '../models/TypePers';
import { MapaINControlNames } from '../service/mapaINControleNames';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
@Component({
  selector: 'app-type-pers',
  templateUrl: './type-pers.component.html'
})
export class TypePersComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypePers';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() personnePhysique: TypePers;

  
  public optionsSelect: any[];
  public optionsSelectType = 'CIVILITE';

  public step12 = new Step12();

  constructor(private autoCompleteService :AutoCompleteService) { }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);

    if(!this.personnePhysique) {
      this.personnePhysique = new TypePers();
    }
    
    if (this.personnePhysique.civilite === null) {
      this.personnePhysique.civilite = '';

    }
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

